import type { ComponentPropsWithoutRef } from "react";
import { responsiveImageSource } from "@/lib/images";

type ResponsiveImageProps = Omit<ComponentPropsWithoutRef<"img">, "src" | "srcSet" | "alt"> & {
  src: string;
  alt: string;
  fill?: boolean;
  priority?: boolean;
};

/** Native img with static src/srcset URLs; no Next.js image optimizer or runtime. */
export default function ResponsiveImage({ src, alt, fill = false, priority = false, width, height, sizes, loading, fetchPriority, decoding = "async", style, ...props }: ResponsiveImageProps) {
  const image = responsiveImageSource(src, typeof width === "number" ? width : undefined);
  return (
    // Native responsive images are a project requirement; variants are generated before builds.
    // eslint-disable-next-line @next/next/no-img-element
    <img
      {...props}
      src={image.src}
      srcSet={image.srcSet}
      sizes={image.srcSet ? sizes ?? (fill ? "100vw" : `${width ?? image.width}px`) : undefined}
      alt={alt}
      width={width ?? image.width}
      height={height ?? image.height}
      loading={priority ? "eager" : loading ?? "lazy"}
      fetchPriority={fetchPriority ?? (priority ? "high" : "auto")}
      decoding={decoding}
      style={fill ? { position: "absolute", inset: 0, width: "100%", height: "100%", ...style } : style}
    />
  );
}
